import { FilterObject } from "../components/SpotInstanceTable/Filter";

export const getCacheKeyFromObject = (filter: any): string => {
  const recordObject = Object.keys(filter).reduce(
    (acc: Record<string, string>, key) => {
      acc[key] = String(filter[key as keyof FilterObject]);
      return acc;
    },
    {},
  );

  return new URLSearchParams(recordObject).toString();
};
